import { render, staticRenderFns } from "./buhzidao.vue?vue&type=template&id=5fa78d63&scoped=true&"
import script from "./buhzidao.vue?vue&type=script&lang=js&"
export * from "./buhzidao.vue?vue&type=script&lang=js&"
import style0 from "./buhzidao.vue?vue&type=style&index=0&id=5fa78d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa78d63",
  null
  
)

export default component.exports